import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import Public from "../../../Layouts/Public";
import PersonalAppFeatures from "../../../components/AppFeatures/PersonalAppFeatures";
import Button from "../../../components/Button/Button";
import FeatureRow from "../../../components/FeatureRow";
import HeroSection, {
  HeroH2,
  HeroH3,
  HeroTitle,
} from "../../../components/HeroSection";
import FillerImage from "../../../components/Images/FillerImage";
import PageSection, {
  StyledSectionHeading,
} from "../../../components/PageSection";
import Spacer from "../../../components/Spacer";
import { siteTitle } from "../../../data/PublicSiteData";
import { trackPageView } from "../../../includes/analytics";
import { Color } from "../../../theme/Color";

const heroImage = (
  <img
    src={`/img/app-screenshots/solo-trip-donegal.webp`}
    alt="Valmeego.com - Locally and beyond"
    style={{ width: "100%", maxWidth: "338px", height: "auto" }}
  />
);

const SoloTrip = () => {
  const router = useRouter();

  trackPageView("/personal/solo-trip");

  return (
    <>
      <NextSeo
        title={`Solo Trips | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />
      <HeroSection
        background={`/img/header-backgrounds/trip-planners-header-background.jpg`}
        image={heroImage}
      >
        <Row center="xs">
          <Col xs={10} sm={10} md={10} lg={12}>
            <Row>
              <HeroTitle>Travel Solo with Confidence!</HeroTitle>
            </Row>
            <Row>
              <HeroH2>
                In your solo travels, you're not just exploring the world;
                you're also discovering yourself along the way.
              </HeroH2>
            </Row>
            <Row>
              <HeroH3>
                Connect with local members and local communities while
                discovering hidden gems and destinations to create lasting
                memories.
              </HeroH3>
              <HeroH3>
                Benefit from the wealth of knowledge shared by fellow travellers
                and locals, gaining insights on where to stay, what to see, what
                to do, and where to eat—every detail that makes your journey
                safer and more memorable.
              </HeroH3>
            </Row>
            <Row>
              <Col xs={12}>
                <Button
                  dataCy="hero-signup-button"
                  color="primary"
                  label="Sign up"
                  size="large"
                  onClick={() => {
                    router.push("/personal/register");
                  }}
                />
                <Row center="xs">Valmeego is free to join and use</Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </HeroSection>

      {/* Features */}
      <PageSection id="features">
        <Spacer top={4} bottom={10}>
          <Row center="xs" middle="xs">
            <StyledSectionHeading>Benefits for Solo Trips</StyledSectionHeading>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={8} style={{ color: Color.Grey2 }}>
              <FeatureRow title="Direct Booking">
                Discover the benefits of booking directly with local businesses.
              </FeatureRow>
              <FeatureRow title="Local Knowledge">
                Access a wealth of local knowledge, recommendations, and insider
                tips shared by locals, travellers, businesses, and destinations.
              </FeatureRow>
              <FeatureRow title="Travel Safely with Confidence">
                Feel confident and secure as you plan your journey. Include a
                trusted friend in your trip on Valmeego and stay in touch as you
                progress for added security.
              </FeatureRow>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Row center="xs">
                <Spacer top={3} right={1} bottom={3} left={1}>
                  <FillerImage
                    src={`/img/content/solo-trip.webp`}
                    alt="Valmeego.com - Locally and beyond"
                    width={265}
                    height={348}
                  />
                </Spacer>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={false} sm={6} md={3}>
              <Row>
                <Spacer top={3} right={1} bottom={1} left={1}>
                  <FillerImage
                    src={`/img/content/skier.png`}
                    alt="Valmeego.com - Locally and beyond"
                    width={265}
                    height={348}
                  />
                </Spacer>
              </Row>
            </Col>
            <Col xs={12} sm={6} md={8} style={{ color: Color.Grey2 }}>
              <FeatureRow title="Make Real Connections">
                Join a global network of visitors and helpful locals. Foster new
                friendships and valuable connections with a like-minded
                community in a positive environment.
              </FeatureRow>
              <FeatureRow title="Explore & Plan">
                Plan endless adventures with Valmeego's trip tool. Organize
                every detail effortlessly, ensuring seamless planning from start
                to finish.
              </FeatureRow>
              <FeatureRow title="Share Your Knowledge">
                Receive daily inspiration from locals and travellers’
                adventures, photos, recommendations, and experiences. Don't miss
                the chance to contribute your own stories and journeys to
                inspire others.
              </FeatureRow>
            </Col>
            <Col xs={8} xsOffset={2} sm={false}>
              <Button
                color="primary"
                label="Sign up"
                size="large"
                onClick={() => {
                  router.push("/personal/register");
                }}
              />
              <Row center="xs" style={{ color: Color.Grey2 }}>
                Valmeego is free to join and use
              </Row>
            </Col>
          </Row>
        </Spacer>
      </PageSection>
      <PersonalAppFeatures />
    </>
  );
};

SoloTrip.Layout = Public;
SoloTrip.Title = "Valmeego - Locally and beyond";

export default SoloTrip;
